import React, { Component } from 'react';
import { Button } from "../../../components/common/index";
import { Row, Col, ModalBody, Modal } from "react-bootstrap";
import './nexusReminderNotificationBox.scss';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { resetNexusReminderNotificationBox } from '../../../redux/actions/V2_0/nexusReminderNotificationBoxActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        nexusReminderNotificationBox: state.nexusReminderNotificationBox
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    resetNexusReminderNotificationBox
};

class NexusReminderNotificationBox extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    };

    handleCallBackFunction(response) {
        if (this.props.nexusReminderNotificationBox.callBackFunction != null) {
            this.props.resetNexusReminderNotificationBox();
            this.props.nexusReminderNotificationBox.callBackFunction(response);
        } else {
            this.props.resetNexusReminderNotificationBox();
        }
    };

    render() {
        return (
            <div>
                <Modal size="md" centered className="nexus-reminder-notification-box" show={this.props.nexusReminderNotificationBox.show === undefined ? false : this.props.nexusReminderNotificationBox.show}>
                    <ModalBody>
                        <div className="nexus-reminder-notification-box-close">
                            <div md="12" >
                                <i class="fa fa-times fa-lg" aria-hidden="true" onClick={() => { this.handleCallBackFunction(false) }} style={{ cursor: "pointer" }}></i>
                            </div>
                        </div>
                        <div className="nexus-reminder-notification-box-header">
                            <div md="12">
                                <h4><b>{this.props.nexusReminderNotificationBox.title === undefined ? "" : this.props.nexusReminderNotificationBox.title}</b></h4>
                            </div>
                        </div>
                        <div className="nexus-reminder-notification-box-body">
                            <div md="12">
                                <div className="nexus-reminder-notification-box-content">
                                    <p style={{ whiteSpace: "pre-line" }}>
                                        {this.props.nexusReminderNotificationBox.content === undefined ? "" : this.props.nexusReminderNotificationBox.content}
                                    </p>


                                    <div md="12" style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <Button sm primary onClick={() => { this.handleCallBackFunction(true) }} className="nexus-reminder-notification-box-register-button">REGISTER ME</Button>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </ModalBody>
                </Modal>

            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NexusReminderNotificationBox);

